'use client'

import { domMax, LazyMotion } from 'motion/react'

/**
 * domMax includes layout features (needed for layoutId shared-element
 * transitions) and drag — both inert if unused, so the only cost is a
 * small bundle bump. Live landing only uses animations; the preview
 * route uses layout for the path-cursor traveling indicator.
 */
export function MotionProvider({ children }: { children: React.ReactNode }) {
    return (
        <LazyMotion features={domMax} strict>
            {children}
        </LazyMotion>
    )
}
